import React from 'react'
import Appbar from '../components/appbar/Appbar'
import { ThemeProvider } from '@mui/system'
import theme, { Colors } from '../styles/theme/'
import Banner from '../components/banner'
import { Box, Container, Typography, Stack, CssBaseline } from '@mui/material'
import { UIProvider } from '../context/ui/'
import Footer from '../components/footer'
import PageFooter from '../components/PageFooter.js'
import TermsAndConditions from '../components/boilerPlate/termsConditions'
import ShipPolicy from '../components/boilerPlate/shipPolicy'
import ReturnPolicy from '../components/boilerPlate/returnPolicy'
import CardSecurity from '../components/boilerPlate/cardsecurity'
import AppDrawer from '../components/drawer'
import { useParams } from 'react-router-dom'
export default function BoilerPlateArray() {
    const { infoType } = useParams()

    const info = {
        terms_conditions: <TermsAndConditions />,
        shipping: <ShipPolicy />,
        return_policy: <ReturnPolicy />,
        card_security: <CardSecurity />,
    }
    const res = info[infoType]

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Container
                maxWidth="lg"
                sx={{
                    // marginTop: { xs: 4, md: 8 },
                    background: theme.palette.primary.main,
                    border: `solid 1px ${Colors.secondary}`,
                }}
            >
                <Stack>
                    <UIProvider>
                        <Appbar />
                        <Banner />
                        {/*    <Promotions />
                          <SearchBox /> */}
                        <Box
                            display="flex"
                            justifyContent="flex-start"
                            sx={{ p: 4 }}
                        >
                            <Typography variant="h4">{res}</Typography>
                        </Box>
                        <Footer />
                        <AppDrawer
                        // onClick={() => setDrawerOpen(false)}
                        ></AppDrawer>
                    </UIProvider>
                </Stack>
                <PageFooter />
            </Container>
        </ThemeProvider>
    )
}
